import { render, staticRenderFns } from "./AppAccountMenu.vue?vue&type=template&id=5b3e4bc2&scoped=true"
import script from "./AppAccountMenu.vue?vue&type=script&lang=js"
export * from "./AppAccountMenu.vue?vue&type=script&lang=js"
import style0 from "./AppAccountMenu.vue?vue&type=style&index=0&id=5b3e4bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e4bc2",
  null
  
)

export default component.exports